import { useTranslation } from "react-i18next";

import ActionButtonLayout from "../layout/ActionButtonLayout";

function FixMachineFailureButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.fixMachineFailure")}</ActionButtonLayout>;

}

export default FixMachineFailureButtonLayout;

